export const imageSize = (url): Promise<any> => {
  const img = document.createElement('img');

  const promise = new Promise((resolve, reject) => {
    img.onload = () => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      return resolve({ width, height });
    };

    img.onerror = reject;
  });

  img.src = url;
  return promise;
};
